import {
  useJsonForms,
  withJsonFormsCellProps,
  withJsonFormsControlProps,
} from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
  CellProps,
  WithClassname,
} from "@jsonforms/core";
import React, { useEffect, useState, useRef } from "react";
import { Input } from "../../../../../../shadcn/components/ui/input";

export const TextDescriptionTypeRenderer = (props: ControlProps) => {
  const { data, handleChange, path, schema, visible, uischema, errors } = props;
  const ctx = useJsonForms();
  const title = schema?.title;
  const inputFieldClassName = uischema?.options?.inputFieldClassName;
  const outerContainerClassName = uischema?.options?.outerContainerClassName;
  const [value, setValue] = React.useState<any>(data === undefined ? "" : data);

  const show = uischema?.options?.show;

  useEffect(() => {
    if (show === false) {
      handleChange(path, "");
      setValue("");
    }
  }, [show]);

  return visible && show ? (
    <>
      <div className={` relative w-full ${outerContainerClassName}`}>
        <textarea
          id="name"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            handleChange(path, e.target.value);
          }}
          className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] min-h-[120px]  outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal  leading-4 text-brand-textLightGrey ${inputFieldClassName}`}
        />
        <label
          htmlFor="name"
          className={`absolute font-openSans font-normal text-web-body-sm leading-3 mid:text-web-body-lg mid:leading-5 ${
            !data ? "text-brand-borderGrey" : "text-transparent hidden"
          } left-4 top-4 pointer-events-none transition-all duration-300 peer-placeholder-shown:top-1.5 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-[10px] peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:leading-[13px] peer-focus:text-brand-orange peer-valid:top-1.5 peer-valid:text-[10px] peer-valid:leading-[13px] peer-valid:text-brand-borderGrey`}
        >
          {title}
        </label>
      </div>
    </>
  ) : (
    <></>
  );
};

export default withJsonFormsControlProps(TextDescriptionTypeRenderer);
